import * as actionTypes from '../actions/actionTypes';

const initialState = {
    show: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.contentLoader.SHOW:
            return {
                ...state,
                show: true,
            };
        case actionTypes.contentLoader.HIDE:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
}

export default reducer;